module.exports = __webpack_public_path__ + "img/ic_inv.337e3a9a.svg";